module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_619936.d1ea3620.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/ift/InternetInRecargas/FormatoSimplificado_619936.pdf
// module id = 890
// module chunks = 0